var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "c-icon-list" },
    _vm._l(_vm.items, function(item) {
      return _c("li", { key: item.index, staticClass: "c-icon-list__item" }, [
        _c(
          "button",
          {
            staticClass: "c-icon-list__link",
            on: {
              click: function($event) {
                return _vm.handleClick(item.title)
              }
            }
          },
          [
            item.icon
              ? _c("span", { staticClass: "c-icon-list__icon" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "c-icon-list__icon-svg",
                      attrs: { "aria-hidden": "true", focusable: "false" }
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "xlink:href": "#" + item.icon
                        }
                      })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "c-icon-list__label" }, [
              _vm._v(_vm._s(item.title))
            ])
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1103bf4b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1103bf4b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/contact-us/_vue/IconList.vue
// module id = 713
// module chunks = 0